import { Box } from "@bca/ui-library";
import styled from "styled-components";
import { position, PositionProps } from "styled-system";
import css from "@styled-system/css";

interface ClickableBoxProps extends PositionProps {
  clickable: boolean;
}

const ClickableBox = styled(Box)<ClickableBoxProps>`
  ${position};
  ${(props) =>
    css({
      cursor: props.clickable ? "pointer" : "not-allowed",
    })}
`;

export default ClickableBox;
